/** @format */

import styled from "@emotion/styled";
import MenuIcon from "@mui/icons-material/Menu";
import { Fragment } from "react";
import LogoImg from "../../assets/image/LaylineShortLogo.png";

import {
  AppBar,
  Avatar,
  Box,
  Button,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import CampaignIcon from "../../assets/svg/CAMPAIGNS ";
import { ScreenDimension } from "../../config/responsiveDimension";
import { updateDrawer } from "../../redux/slice/userSlice";
import { DOMAIN_NAME } from "../../utils/config";
const TopBar = () => {
  const location = useLocation();
  const pathName = location.pathname;

  const dispatch = useDispatch();
  const { MLG } = ScreenDimension();
  // const fetchUserDetails = async () => {
  //   try {
  //     const response = await axios.get(API_ROUTES.GET_USER_DETAILS, {
  //       headers: {
  //         Authorization: `Bearer ${getCookie("ssoToken")}`,
  //       },
  //     });
  //     const value = response?.data?.data;
  //     if (value) {
  //       dispatch(updateAdminDetails([value]));
  //       const isFinished = await fetchUpdateClientBrandId(
  //         value?.current_client_id,
  //         dispatch
  //       );
  //       return isFinished;
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     return false;
  //   }
  // };
  const adminDetails = useSelector((state) => state.user.adminDetails);

  // const sideBarContent = [
  //   {
  //     name: "Dashboard",
  //     navigation: RoutesPath.DASHBOARD,
  //     status: "Dashboard",
  //   },
  //   {
  //     name: "SMS Campaign",
  //     navigation: RoutesPath.CAMPAIGNHISTORY,
  //     status: "Sms Campaign",
  //   },
  //   { name: "List", navigation: RoutesPath.List, status: "List" },
  //   {
  //     name: "Contact",
  //     navigation: RoutesPath.CONTACT,
  //     status: "Contact",
  //   },
  // ];

  // const handleUrlPermission = async () => {
  //   try {
  //     const response = await axios.get(PERMISSION_URL, {
  //       headers: {
  //         authorization: `Bearer ${getCookie("ssoToken")}`,
  //       },
  //     });
  //     const value = response?.data?.data || [];
  //     dispatch(updatePermission(value));

  //     const getSetterStatus = value?.find((v) =>
  //       removeWhiteSpace(v?.mainMenu)?.includes(removeWhiteSpace("Campaigns"))
  //     );

  //     const checkPageAccess = getSetterStatus?.subMenus?.find((v) => v?.status);
  //     if (!getSetterStatus?.status || !checkPageAccess) {
  //       window.open(DOMAIN_NAME?.layline, "_self");
  //     } else {
  //       const findStatus = sideBarContent?.find((v) =>
  //         checkPageAccess?.menu?.includes(v?.status)
  //       )?.navigation;

  //       const isFinished = await fetchUserDetails();
  //       if (isFinished) {
  //         Navigation(findStatus, {
  //           replace: true,
  //         });
  //       }
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  return (
    // <OverallContainer>
    //   <Toolbar>
    //     {/* Menu Icon to toggle the sidebar */}
    //     {location.pathname !== "/" && (
    //       <IconButton
    //         size="large"
    //         edge="start"
    //         color="black"
    //         aria-label="menu"
    //         onClick={toggleSidebar} // Call toggleSidebar when clicked
    //         sx={{ mr: 2, display: { xs: "block", md: "none" } }}
    //       >
    //         <MenuIcon color="black" />
    //       </IconButton>
    //     )}
    //     {/* Logo and Title */}
    //     <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
    //       <ImageContainer
    //         onClick={() => Navigation(RoutesPath.CAMPAIGNHISTORY)}
    //       >
    //         <img
    //           src={LogoImg}
    //           alt="Layline"
    //           style={{ height: "30px", width: "132px" }}
    //         />
    //       </ImageContainer>
    //     </Box>

    //     {location.pathname !== "/" && (
    //       <>
    //         <RightnavContainer sx={{ display: "flex", alignItems: "center" }}>
    //           <Avatar alt="User  Avatar" />
    //         </RightnavContainer>
    //         <Drawer anchor="left" open={isOpen} onClose={toggleSidebar}>
    //           <Box
    //             sx={{ width: 250, padding: "1rem" }}
    //             role="presentation"
    //             onClick={toggleSidebar}
    //             onKeyDown={toggleSidebar}
    //           >
    //             {/* <IconButton onClick={toggleSidebar}>
    //           <CloseIcon />
    //         </IconButton> */}
    //             {sideBarContent.map((value, index) => (
    //               <NavLinkStyled key={index} to={value.navigation}>
    //                 {value.icon}
    //                 <Menus>{value.name}</Menus>
    //               </NavLinkStyled>
    //             ))}
    //           </Box>
    //         </Drawer>
    //       </>
    //     )}
    //   </Toolbar>
    // </OverallContainer>
    <Fragment>
      <AppBar
        color="background.paper"
        sx={{
          width: "100%",
          height: "100%",
          zIndex: 1000,
          position: "sticky",
          bgcolor: "background.default",
          boxShadow: "0px 1px 4px 0px #00000029",
        }}
        elevation={0}
      >
        <Toolbar>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              height: "100%",
              justifyContent: "space-between",
            }}
          >
            {!MLG && (
              <Button onClick={() => dispatch(updateDrawer())}>
                <MenuIcon />
              </Button>
            )}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                columnGap: "1rem",
              }}
            >
              <IconButton
                sx={{
                  padding: 0,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: 40, // Adjust as per design
                  width: 40, // Match height for a square button
                }}
                LinkComponent={"a"}
                target="_blank"
                href={DOMAIN_NAME.layline}
                aria-label="Navigate to homepage"
              >
                <img
                  src={LogoImg}
                  alt="MNlogo"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    aspectRatio: "1",
                  }}
                />
              </IconButton>
              <CampaignIcon height={40} width={40} />
              <Typography sx={{ fontSize: "1.25rem", color: "text.primary" }}>
                Campaigns
              </Typography>
            </Box>

            {pathName !== "/" && (
              <Box>
                <IconButton LinkComponent={"a"} href={DOMAIN_NAME.config}>
                  <Avatar src={adminDetails?.[0]?.profileImage} alt="profile" />
                </IconButton>
              </Box>
            )}
          </Box>
        </Toolbar>
      </AppBar>
    </Fragment>
  );
};

export default TopBar;
const OverallContainer = styled(AppBar)(() => ({
  height: "70px",
  backgroundColor: "#FDFDFD",
  boxShadow: "0px 1px 4px 0px #00000029",
  position: "sticky",
  padding: "8px 24px",
}));

const ImageContainer = styled(Box)(() => ({
  paddingRight: 10,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  aspectRatio: 2.5,
  cursor: "pointer",
}));
const RightnavContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 10,
  justifyContent: "flex-end",
}));

const NavLinkStyled = styled(NavLink)(({ theme }) => ({
  textDecoration: "none",
  // color: ,
  marginTop: "1rem",
  gap: "24px",
  display: "flex",
  alignItems: "center",
}));
const Menus = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.heading1,
}));
